<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
import {
  apiLogin,
} from '@/apis/api'
export default {
  name: 'App',
  data() {
    return {
      instance: null,
      isZoomOpen: false
    };
  },
  mounted() {
    const that = this;
    this.isZoom();
    window.addEventListener("resize", function () {
      that.isZoom();
    });
    let login = apiLogin();
  },
  methods: {
    detectZoom() {
      let ratio = 0,
        screen = window.screen,
        ua = navigator.userAgent.toLowerCase();
      //
      if (~ua.indexOf("firefox")) {
        if (window.devicePixelRatio !== undefined) {
          ratio = window.devicePixelRatio;
        }
      } else if (~ua.indexOf("msie")) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      } else if (
        window.outerWidth !== undefined &&
        window.innerWidth !== undefined
      ) {
        ratio = window.outerWidth / window.innerWidth;
      }
      //
      if (ratio) {
        ratio = Math.round(ratio * 100);
      }
      // 360安全浏览器下的innerWidth包含了侧边栏的宽度
      if (ratio !== 100) {
        if (ratio >= 95 && ratio <= 105) {
          ratio = 100;
        }
      }
      return ratio;
    },
    isZoom() {
      if (this.detectZoom() < 100 || this.detectZoom() > 100) {
        this.zoomNotifyOpen();
      } else {
        this.zoomNotifyClose();
      }
    },
    zoomNotifyOpen: function () {
      if (!this.isZoomOpen) {
        this.isZoomOpen = true; // 加上标记防止多次提示
        this.instance = this.$notify({
          title: "提示",
          message:
            "您的浏览器目前处于缩放状态，页面可能会出现错位现象，建议100%大小显示",
          type: "info",
          duration: 0
        });
      }
    },
    zoomNotifyClose: function () {
      if (this.instance !== null) {
        // 判断是否为null 防止bug
        this.instance.close();
        this.isZoomOpen = false;
      }
    }
  }
};
</script>

<style>
body,
html,
#app {
  height: 100%;
  overflow: hidden;
}

@page {
  size: auto;
  /* auto is the initial value */
  margin: 3mm;
  /* this affects the margin in the printer settings */
}

.twipsy {
  position: absolute;
  max-width: 300px;
  min-width: 100px;
  padding: 5px;
  font-size: 12px;
  z-index: 1000;
  opacity: 0.8;
}

.twipsy-arrow {
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -5px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 5px solid #000000;
}

.twipsy-inner {
  padding: 3px 8px;
  background-color: #000000;
  color: white;
  text-align: center;
  max-width: 300px;
  text-decoration: none;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue